/**
 * LinkedIn Connect Object
 *
 * Initiates the OAuth flow with the correct parameters given the configuration
 * specified
 */
import "../vendor/bootbox.min.js"

function LIConnect(config) {
  let trackingId = null

  if (config === undefined) {
    return
  }

  this.config = config

  this.oauth_base_url =
    "https://" + this.config.host + "/uas/oauth2/authorization?" + "response_type=code&client_id=" + this.config.apiKey
  this.config.login_source = this.config.login_source === "" ? "li-connect" : this.config.login_source
  this.config.connectRoute = !this.config.connectRoute ? "connect" : this.config.connectRoute
  this.config.scope = this.config.scope || ""

  this.$buttonConnect = $(this.config.connectButtonClass)

  trackingId = this.$buttonConnect.attr("data-tracking-id")

  if (getUrlVar("re_auth") !== undefined) {
    this.config.re_auth = true
  }
  this.config.connectRoutePrefix = !this.config.connectRoutePrefix ? "w/liconnect" : this.config.connectRoutePrefix

  let submit_url = decodeURIComponent(
    document.location.protocol + "//" + document.location.host + document.location.pathname
  )

  this.config.connectUrl =
    "https:" +
    "//" +
    window.location.host +
    "/" +
    this.config.connectRoutePrefix +
    "/" +
    this.config.connectRoute +
    "?login_source=" +
    this.config.login_source +
    "&submit_url=" +
    submit_url
  if (trackingId) {
    this.config.connectUrl += "&tracking_id=" + trackingId
  }
  if (this.config.re_auth !== undefined) {
    this.config.connectUrl += "&re_auth=" + this.config.re_auth
  }

  this.bindEvents()

  slideshare_object.registerMessageReceiver($.proxy(this.messageReceiver, this))
}

let timer

/**
 * Open the OAuth dialog
 */
LIConnect.prototype.openAuthDialog = function (url) {
  if (url === undefined) {
    url = this.config.connectUrl
  }
  let oauth_url = [
    this.oauth_base_url,
    "scope=" + this.config.scope,
    "state=" + this.config.state,
    "redirect_uri=" + encodeURIComponent(url),
    "_l=" + slideshare_object.utils.i18n_locale(),
  ].join("&")

  window.liChildWindow = window.open(
    oauth_url,
    "_blank",
    "height=400,width=600,status=yes,toolbar=no,menubar=no,location=no,scrollbars=yes"
  )
  // For IE and mobile browsers, the linkedin child window does not post
  // the message to parent window. This is a hack to poll the child window
  // periodically and reload the parent window once it closes.
  if (
    isBrowserMSIE() ||
    navigator.userAgent.match(/iPhone|iPad|iPod|Android|BlackBerry|IEMobile|webOS|Mobile|Windows Phone/i)
  ) {
    timer = setInterval(this.checkChild.bind(this), 500)
  }
}

/**
 * Binds the click event on the LinkedIn connect button
 */
LIConnect.prototype.bindEvents = function () {
  let that = this
  this.$buttonConnect.on("click", function (e) {
    that.openAuthDialog()
  })
}

/**
 * Checks for the dialog window states for some browsers where cross-window
 * messaging is not available and process manually with the expected action
 * on the parent window
 */
LIConnect.prototype.checkChild = function () {
  //closed property is set to undefined instead of true for android browsers
  if (window.liChildWindow.closed != false) {
    clearInterval(timer)
    let isIFrame = window.location != window.parent.location
    if (isIFrame) {
      $.postMessage("modalLoginSubmit", $("#target_url").val(), parent)
    } else {
      window._gaq = _gaq || []
      _gaq.push(["_trackEvent", "Login", "linkedin", "login_successful"])
      if (this.config.postAuthUrl) {
        window.location = this.config.postAuthUrl
      } else {
        window.location.reload()
      }
    }
  }
}

LIConnect.prototype.uploadToLiCallback = function (ssid) {
  let addToProfile = $("#li_upload_" + ssid)
  addToProfile.removeClass("j-linkedin-connect")
  addToProfile.addClass("added")
  $("#li_upload_" + ssid + " .flat-button-text").text("Added to profile")
  slideshare_object.ga("Treasury", "linkedin", "connect_and_upload_success")
}

LIConnect.prototype.updateState = function (state) {
  this.config.state = state
}

// Binds messages received from LinkedIn Connect popup window
// using jQuery cross-domain messaging plugin
LIConnect.prototype.messageReceiver = function (message) {
  let i18n = slideshare_object.utils.i18n

  switch (message) {
    case "liconnectSubmit":
      slideshare_object.ga("Login", "linkedin", "login_successful")
      var fromSource = getUrlVar("from_source")
      if (fromSource !== undefined && isInternalRedirect(fromSource)) {
        window.location = decodeURIComponent(fromSource)
      } else {
        window.location = "/?from=login"
      }
      break
    case "liconnectSubmitVisualResume":
      window.location = "/professional-journey/show"
      break
    case "liconnectModalSubmit":
      $.postMessage("modalLoginSubmit", $("#target_url").val(), parent)
      break
    case "liUploadSubmit":
      this.uploadToLiCallback(this.config.slideshow_id)
      window.bootbox.alert(i18n("li_connect.slideshare_added"))
      break
    case "liNewUserUpload":
      $("#j-linkedinConnectedMessage").modal("show")
      this.uploadToLiCallback(this.config.slideshow_id)
    case "liconnectLeadGen":
      var fromSource = getUrlVar("from_source")
      if (fromSource !== undefined && isInternalRedirect(fromSource)) {
        window.location = decodeURIComponent(fromSource)
      } else {
        window.location = "/lead-campaigns"
      }
      break
    case "liconnectLeadGenNew":
      // Submit new lead campaign form
      slideshare_object.leadCampaignForm.form.submitForm()
      break
    case "liconnectReAuthFail":
      $(".j-alert").html(i18n("li_connect.login.no_match"))
      $(".j-alert").removeClass("hide").show()
      break
  }
}

window.LIConnect = LIConnect
